import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
} from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { Add, Delete, LocationCity, Map, Save, Search } from "@material-ui/icons"
import { useSnackbar } from "../../../utils/notificacoes"
import React, { useEffect, useState } from "react"
import useAppStore from "../../../stores/AppStore"
import { AtribuirBairrosActionsTypes } from "../context/atribuirBairrosActions"
import { useAtribuirBairrosContext } from "../context/useAtribuirBairrosContext"
import type { BairroAtendido, CidadeView } from "../models/atribuirBairrosModel"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: { paddingLeft: "20px", paddingRight: "20px", paddingTop: "80px" },
        [theme.breakpoints.down("sm")]: { paddingLeft: "15px", paddingRight: "15px", paddingTop: "70px" },
    },
    content: {
        margin: "auto",
        maxWidth: "1760px",
        [theme.breakpoints.down("sm")]: { maxWidth: "100%" },
    },
    header: {
        marginBottom: theme.spacing(3),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: theme.spacing(2),
        [theme.breakpoints.down("sm")]: { flexDirection: "column", alignItems: "flex-start" },
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: { fontSize: "1.5rem" },
        [theme.breakpoints.down("xs")]: { fontSize: "1.25rem" },
    },
    configCard: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("sm")]: { borderRadius: 15, marginBottom: theme.spacing(2) },
    },
    cardHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2.5),
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
    },
    cardHeaderTitle: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: { fontSize: "1.1rem" },
    },
    iconHeader: {
        color: "#4caf50",
        marginRight: theme.spacing(1),
    },
    iconHeaderRed: {
        color: "var(--cor-erro)",
        marginRight: theme.spacing(1),
    },
    tableHead: {
        backgroundColor: "#f8f9fa",
    },
    tableHeadCell: {
        fontWeight: 600,
        color: "#2c3e50",
        whiteSpace: "nowrap",
    },
    tableInput: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 8,
            "& fieldset": { borderColor: "#e0e0e0" },
            "&:hover fieldset": { borderColor: "#4caf50" },
            "&.Mui-focused fieldset": { borderColor: "#4caf50" },
        },
    },
    deleteButton: {
        color: "var(--cor-erro)",
        "&:hover": { backgroundColor: "rgba(var(--cor-erro-rgb),0.08)" },
    },
    saveRowButton: {
        color: "#4caf50",
        "&:hover": { backgroundColor: "rgba(var(--cor-botao-salvar-rgb),0.08)" },
    },
    addButton: {
        borderRadius: 25,
        backgroundColor: "var(--cor-botao-salvar)",
        color: "white",
        padding: theme.spacing(1.5, 4),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(var(--cor-botao-salvar-rgb), 0.3)",
        "&:hover": {
            backgroundColor: "var(--cor-botao-salvar-hover)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(var(--cor-botao-salvar-rgb), 0.4)",
        },
        "&:disabled": { backgroundColor: "#a5d6a7", boxShadow: "none" },
        [theme.breakpoints.down("sm")]: { minWidth: "100%" },
    },
    cidadeButton: {
        borderRadius: 20,
        fontWeight: 600,
    },
    cidadeTab: {
        display: "inline-flex",
        alignItems: "center",
        padding: "6px 16px",
        borderRadius: 20,
        marginRight: 8,
        marginBottom: 8,
        cursor: "pointer",
        fontWeight: 600,
        fontSize: "0.875rem",
        border: "2px solid transparent",
        transition: "all 0.2s",
    },
    cidadeTabAtiva: {
        backgroundColor: "var(--cor-botao-salvar)",
        color: "white",
        border: "2px solid #388e3c",
    },
    cidadeTabInativa: {
        backgroundColor: "#f8f9fa",
        color: "#2c3e50",
        border: "2px solid #e9ecef",
        "&:hover": { borderColor: "#4caf50" },
    },
    taxaForm: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "flex-end",
        flexWrap: "wrap",
        padding: theme.spacing(2),
        backgroundColor: "#f8f9fa",
        borderRadius: 12,
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: { flexDirection: "column" },
    },
    panelGrid: {
        display: "grid",
        // Painel "Nao Atendidos" e uma lista simples (checkbox + nome) e precisa de
        // pouco espaco; "Atendidos" tem varias colunas (tabela minWidth 720) -> damos
        // mais largura a ele. minmax(0, ...) deixa a tabela caber/rolar sem transbordar.
        gridTemplateColumns: "minmax(280px, 0.75fr) minmax(0, 1.25fr)",
        gap: theme.spacing(3),
        [theme.breakpoints.down("md")]: { gridTemplateColumns: "1fr" },
    },
    nomeCell: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
}))

function MoneyInput({
    label,
    value,
    onChange,
    required,
    className,
}: {
    label: string
    value: string
    onChange: (v: string) => void
    required?: boolean
    className?: string
}) {
    return (
        <TextField
            className={className}
            label={label}
            variant="outlined"
            size="small"
            value={value.replace(".", ",")}
            onChange={e => onChange(e.target.value.replace(",", "."))}
            error={required && !value.trim()}
        />
    )
}

function BairroAtendidoLinha({
    bairro,
    mostrarNoturna,
    mostrarMinimo,
    mostrarEntregador,
    onRemover,
    onAtualizar,
}: {
    bairro: BairroAtendido
    mostrarNoturna: boolean
    mostrarMinimo: boolean
    mostrarEntregador: boolean
    onRemover: () => void
    onAtualizar: (payload: {
        taxaEntrega: string
        taxaEntregaNoturna: string | null
        minimoEntregaGratis: string | null
        taxaEntregador: string | null
    }) => void
}) {
    const [taxa, setTaxa] = useState(bairro.taxaEntrega ?? "")
    const [noturna, setNoturna] = useState(bairro.taxaEntregaNoturna ?? "")
    const [minimo, setMinimo] = useState(bairro.minimoEntregaGratis ?? "")
    const [entregador, setEntregador] = useState(bairro.taxaEntregador ?? "")
    const classes = useStyles()

    useEffect(() => {
        setTaxa(bairro.taxaEntrega ?? "")
        setNoturna(bairro.taxaEntregaNoturna ?? "")
        setMinimo(bairro.minimoEntregaGratis ?? "")
        setEntregador(bairro.taxaEntregador ?? "")
    }, [bairro])

    const handleSalvar = () => {
        onAtualizar({
            taxaEntrega: taxa.replace(",", "."),
            taxaEntregaNoturna: noturna ? noturna.replace(",", ".") : null,
            minimoEntregaGratis: minimo ? minimo.replace(",", ".") : null,
            taxaEntregador: entregador ? entregador.replace(",", ".") : null,
        })
    }

    return (
        <TableRow>
            <TableCell className={classes.nomeCell} title={bairro.nomeBairro}>{bairro.nomeBairro}</TableCell>
            <TableCell>
                <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={taxa.replace(".", ",")}
                    onChange={e => setTaxa(e.target.value.replace(",", "."))}
                />
            </TableCell>
            {mostrarNoturna && (
                <TableCell>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={noturna.replace(".", ",")}
                        onChange={e => setNoturna(e.target.value.replace(",", "."))}
                    />
                </TableCell>
            )}
            {mostrarMinimo && (
                <TableCell>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={minimo.replace(".", ",")}
                        onChange={e => setMinimo(e.target.value.replace(",", "."))}
                    />
                </TableCell>
            )}
            {mostrarEntregador && (
                <TableCell>
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={entregador.replace(".", ",")}
                        onChange={e => setEntregador(e.target.value.replace(",", "."))}
                    />
                </TableCell>
            )}
            <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                <Tooltip title="Salvar taxas">
                    <IconButton size="small" className={classes.saveRowButton} onClick={handleSalvar}>
                        <Save fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Remover bairro">
                    <IconButton size="small" className={classes.deleteButton} onClick={onRemover}>
                        <Delete fontSize="small" />
                    </IconButton>
                </Tooltip>
            </TableCell>
        </TableRow>
    )
}

export function BairrosEstabelecimentoForm() {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { dados, dispatch, adicionarBairros, removerBairro, atualizarTaxa, adicionarCidade, removerCidade, carregarBairros, erroCarregamento } =
        useAtribuirBairrosContext()
    const { enqueueSnackbar } = useSnackbar()
    const configuracoes = useAppStore(s => s.configuracoes)
    const mostrarNoturna = configuracoes?.user?.parametros?.permiteTaxaEntregaNoturna ?? false
    const mostrarMinimo = true
    const mostrarEntregador = true

    const { atendidos, naoAtendidos, cidadesEstabelecimento, todasCidades, idCidadeSelecionada, idsBairrosSelecionados, taxa, taxaNoturna, minimoEntregaGratis, taxaEntregador } = dados

    const [termoBusca, setTermoBusca] = useState("")

    const normalizar = (s: string) =>
        s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()

    const naoAtendidosFiltrados = termoBusca
        ? naoAtendidos.filter(b => normalizar(b.nome).startsWith(normalizar(termoBusca)))
        : naoAtendidos

    const todosSelecionados =
        naoAtendidos.length > 0 && idsBairrosSelecionados.length === naoAtendidos.length

    useEffect(() => {
        if (erroCarregamento) {
            enqueueSnackbar("Erro ao carregar bairros", { variant: "error" })
        }
    }, [erroCarregamento])

    const handleSelecionarCidade = (id: number) => {
        dispatch({ type: AtribuirBairrosActionsTypes.SELECIONAR_CIDADE, payload: id })
        carregarBairros(id)
    }

    const handleToggleTodos = () => {
        dispatch({ type: AtribuirBairrosActionsTypes.TOGGLE_TODOS, payload: !todosSelecionados })
    }

    const handleAdicionarBairros = async () => {
        if (!taxa.trim()) {
            enqueueSnackbar("Informe a taxa de entrega antes de adicionar os bairros", { variant: "error" })
            return
        }
        if (idsBairrosSelecionados.length === 0) {
            enqueueSnackbar("Selecione ao menos um bairro", { variant: "error" })
            return
        }
        try {
            await adicionarBairros()
            enqueueSnackbar("Bairros adicionados com sucesso!", { variant: "success" })
        } catch (error) {
            enqueueSnackbar((error as Error).message || "Erro ao adicionar bairros", { variant: "error" })
        }
    }

    const [confirmacaoAberta, setConfirmacaoAberta] = useState(false)
    const [idParaRemover, setIdParaRemover] = useState<number | null>(null)

    const handleRemover = (id: number) => {
        setIdParaRemover(id)
        setConfirmacaoAberta(true)
    }

    const handleConfirmarRemocao = async () => {
        if (idParaRemover === null) return
        setConfirmacaoAberta(false)
        setIdParaRemover(null)
        try {
            await removerBairro(idParaRemover)
            enqueueSnackbar("Bairro removido com sucesso!", { variant: "success" })
        } catch (error) {
            enqueueSnackbar((error as Error).message || "Erro ao remover bairro", { variant: "error" })
        }
    }

    const handleAtualizarTaxa = async (
        id: number,
        payload: {
            taxaEntrega: string
            taxaEntregaNoturna: string | null
            minimoEntregaGratis: string | null
            taxaEntregador: string | null
        }
    ) => {
        try {
            await atualizarTaxa(id, payload)
            enqueueSnackbar("Taxas atualizadas com sucesso!", { variant: "success" })
        } catch (error) {
            enqueueSnackbar((error as Error).message || "Erro ao atualizar taxas", { variant: "error" })
        }
    }

    // Modal cidades
    const [modalCidadeAberto, setModalCidadeAberto] = useState(false)
    const [modalRemoverCidadeAberto, setModalRemoverCidadeAberto] = useState(false)
    const [cidadeSelecionadaAdicionar, setCidadeSelecionadaAdicionar] = useState<CidadeView | null>(null)
    const [cidadeSelecionadaRemover, setCidadeSelecionadaRemover] = useState<number | "">("")

    const handleAdicionarCidade = async () => {
        if (!cidadeSelecionadaAdicionar) return
        try {
            await adicionarCidade(cidadeSelecionadaAdicionar.id)
            enqueueSnackbar("Cidade adicionada com sucesso!", { variant: "success" })
            setModalCidadeAberto(false)
            setCidadeSelecionadaAdicionar(null)
        } catch (error) {
            enqueueSnackbar((error as Error).message || "Erro ao adicionar cidade", { variant: "error" })
        }
    }

    const handleRemoverCidade = async () => {
        if (!cidadeSelecionadaRemover) return
        try {
            await removerCidade(cidadeSelecionadaRemover as number)
            enqueueSnackbar("Cidade removida com sucesso!", { variant: "success" })
            setModalRemoverCidadeAberto(false)
            setCidadeSelecionadaRemover("")
        } catch (error) {
            enqueueSnackbar((error as Error).message || "Erro ao remover cidade", { variant: "error" })
        }
    }

    return (
        <div className={classes.container}>
            <div className={classes.content}>
                {/* Header */}
                <Box className={classes.header}>
                    <Box>
                        <Typography variant="h4" className={classes.titleText}>
                            Áreas de Entrega
                        </Typography>
                        <Typography variant="subtitle1" style={{ color: "#7f8c8d", marginTop: 4 }}>
                            Defina os bairros que seu delivery atende e as taxas cobradas
                        </Typography>
                    </Box>
                    <Box display="flex" gridGap={8} flexWrap="wrap">
                        <Button
                            variant="outlined"
                            className={classes.cidadeButton}
                            style={{ borderColor: "#4caf50", color: "#4caf50" }}
                            onClick={() => setModalCidadeAberto(true)}
                            disabled={!!erroCarregamento}
                            startIcon={<Add />}
                        >
                            Adicionar Cidade
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.cidadeButton}
                            style={{ borderColor: "var(--cor-erro)", color: "var(--cor-erro)" }}
                            onClick={() => setModalRemoverCidadeAberto(true)}
                            disabled={!!erroCarregamento || cidadesEstabelecimento.length === 0}
                        >
                            Remover Cidade
                        </Button>
                    </Box>
                </Box>

                {/* Seletor de cidade */}
                {cidadesEstabelecimento.length > 0 && (
                    <Box mb={2} display="flex" flexWrap="wrap" alignItems="center">
                        <LocationCity style={{ color: "#7f8c8d", marginRight: 8 }} />
                        {cidadesEstabelecimento.map(c => (
                            <span
                                key={c.id}
                                className={`${classes.cidadeTab} ${
                                    idCidadeSelecionada === c.id
                                        ? classes.cidadeTabAtiva
                                        : classes.cidadeTabInativa
                                }`}
                                onClick={() => handleSelecionarCidade(c.id)}
                            >
                                {c.nome}
                            </span>
                        ))}
                    </Box>
                )}

                {/* Formulário de taxas para adição */}
                <Box className={classes.taxaForm}>
                    <Typography variant="body2" style={{ color: "#2c3e50", fontWeight: 600, width: "100%" }}>
                        Taxas para bairros selecionados:
                    </Typography>
                    <MoneyInput
                        label="Taxa de Entrega *"
                        value={taxa}
                        onChange={v => dispatch({ type: AtribuirBairrosActionsTypes.ATUALIZAR_CAMPO_FORM, payload: { campo: "taxa", valor: v } })}
                        required
                    />
                    {mostrarNoturna && (
                        <MoneyInput
                            label="Taxa Noturna"
                            value={taxaNoturna}
                            onChange={v => dispatch({ type: AtribuirBairrosActionsTypes.ATUALIZAR_CAMPO_FORM, payload: { campo: "taxaNoturna", valor: v } })}
                        />
                    )}
                    <MoneyInput
                        label="Mín. p/ Entrega Grátis"
                        value={minimoEntregaGratis}
                        onChange={v => dispatch({ type: AtribuirBairrosActionsTypes.ATUALIZAR_CAMPO_FORM, payload: { campo: "minimoEntregaGratis", valor: v } })}
                    />
                    <MoneyInput
                        label="Taxa Entregador"
                        value={taxaEntregador}
                        onChange={v => dispatch({ type: AtribuirBairrosActionsTypes.ATUALIZAR_CAMPO_FORM, payload: { campo: "taxaEntregador", valor: v } })}
                    />
                    <Button
                        variant="contained"
                        className={classes.addButton}
                        startIcon={<Add />}
                        onClick={handleAdicionarBairros}
                        disabled={!!erroCarregamento || idsBairrosSelecionados.length === 0}
                    >
                        Adicionar {idsBairrosSelecionados.length > 0 ? `(${idsBairrosSelecionados.length})` : "Bairros"}
                    </Button>
                </Box>

                {/* Dois painéis lado a lado */}
                <div className={classes.panelGrid}>
                    {/* Painel esquerdo: bairros não atendidos */}
                    <Paper className={classes.configCard}>
                        <Box className={classes.cardHeader}>
                            <Box display="flex" alignItems="center">
                                <Map className={classes.iconHeaderRed} />
                                <Typography variant="h6" className={classes.cardHeaderTitle}>
                                    Não Atendidos
                                    {naoAtendidos.length > 0 && (
                                        <Typography
                                            component="span"
                                            variant="caption"
                                            style={{ color: "#7f8c8d", marginLeft: 8 }}
                                        >
                                            ({naoAtendidos.length} bairros)
                                        </Typography>
                                    )}
                                </Typography>
                            </Box>
                            {naoAtendidos.length > 0 && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={todosSelecionados}
                                            onChange={handleToggleTodos}
                                            size="small"
                                            style={{ color: "#4caf50" }}
                                        />
                                    }
                                    label={
                                        <Typography variant="caption" style={{ color: "#7f8c8d" }}>
                                            Todos
                                        </Typography>
                                    }
                                />
                            )}
                        </Box>
                        <Box style={{ padding: "8px 16px", borderBottom: "1px solid #e9ecef" }}>
                            <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                placeholder="Buscar bairro..."
                                value={termoBusca}
                                onChange={e => setTermoBusca(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search style={{ color: "#7f8c8d", fontSize: 20 }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        <TableContainer style={{ maxHeight: "calc(100vh - 360px)", minHeight: 320, overflowX: "auto" }}>
                            <Table size="small" stickyHeader style={{ minWidth: 260, width: "100%" }}>
                                <TableHead className={classes.tableHead}>
                                    <TableRow>
                                        <TableCell className={classes.tableHeadCell} style={{ minWidth: 48 }} />
                                        <TableCell className={classes.tableHeadCell}>Bairro</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {naoAtendidos.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={2} align="center" style={{ color: "#7f8c8d", padding: 24 }}>
                                                {idCidadeSelecionada
                                                    ? "Todos os bairros desta cidade já estão atendidos."
                                                    : "Selecione uma cidade acima."}
                                            </TableCell>
                                        </TableRow>
                                    ) : naoAtendidosFiltrados.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={2} align="center" style={{ color: "#7f8c8d", padding: 24 }}>
                                                Nenhum bairro encontrado para "{termoBusca}".
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        naoAtendidosFiltrados.map(b => (
                                            <TableRow
                                                key={b.id}
                                                hover
                                                selected={idsBairrosSelecionados.includes(b.id)}
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                    dispatch({
                                                        type: AtribuirBairrosActionsTypes.TOGGLE_BAIRRO,
                                                        payload: b.id,
                                                    })
                                                }
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={idsBairrosSelecionados.includes(b.id)}
                                                        size="small"
                                                        style={{ color: "#4caf50" }}
                                                        onClick={e => e.stopPropagation()}
                                                        onChange={() =>
                                                            dispatch({
                                                                type: AtribuirBairrosActionsTypes.TOGGLE_BAIRRO,
                                                                payload: b.id,
                                                            })
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell className={classes.nomeCell} title={b.nome}>{b.nome}</TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>

                    {/* Painel direito: bairros atendidos */}
                    <Paper className={classes.configCard}>
                        <Box className={classes.cardHeader}>
                            <Box display="flex" alignItems="center">
                                <Map className={classes.iconHeader} />
                                <Typography variant="h6" className={classes.cardHeaderTitle}>
                                    Atendidos
                                    {atendidos.length > 0 && (
                                        <Typography
                                            component="span"
                                            variant="caption"
                                            style={{ color: "#7f8c8d", marginLeft: 8 }}
                                        >
                                            ({atendidos.length} bairros)
                                        </Typography>
                                    )}
                                </Typography>
                            </Box>
                        </Box>
                        <TableContainer style={{ maxHeight: "calc(100vh - 360px)", minHeight: 320, overflowX: "auto" }}>
                            <Table size="small" stickyHeader style={{ minWidth: 720, width: "100%" }}>
                                <TableHead className={classes.tableHead}>
                                    <TableRow>
                                        <TableCell className={classes.tableHeadCell} style={{ minWidth: 160 }}>Bairro</TableCell>
                                        <TableCell className={classes.tableHeadCell} style={{ minWidth: 110 }}>Taxa (R$)</TableCell>
                                        {mostrarNoturna && (
                                            <TableCell className={classes.tableHeadCell} style={{ minWidth: 110 }}>Tx. Noite</TableCell>
                                        )}
                                        {mostrarMinimo && (
                                            <TableCell className={classes.tableHeadCell} style={{ minWidth: 120 }}>Mín. Grátis</TableCell>
                                        )}
                                        {mostrarEntregador && (
                                            <TableCell className={classes.tableHeadCell} style={{ minWidth: 130 }}>Tx. Entregador</TableCell>
                                        )}
                                        <TableCell style={{ minWidth: 90 }} />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {atendidos.length === 0 ? (
                                        <TableRow>
                                            <TableCell
                                                colSpan={
                                                    2 +
                                                    (mostrarNoturna ? 1 : 0) +
                                                    (mostrarMinimo ? 1 : 0) +
                                                    (mostrarEntregador ? 1 : 0) +
                                                    1
                                                }
                                                align="center"
                                                style={{ color: "#7f8c8d", padding: 24 }}
                                            >
                                                Nenhum bairro atendido nesta cidade ainda.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        atendidos.map(b => (
                                            <BairroAtendidoLinha
                                                key={b.id}
                                                bairro={b}
                                                mostrarNoturna={mostrarNoturna}
                                                mostrarMinimo={mostrarMinimo}
                                                mostrarEntregador={mostrarEntregador}
                                                onRemover={() => handleRemover(b.id)}
                                                onAtualizar={payload => handleAtualizarTaxa(b.id, payload)}
                                            />
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </div>
            </div>

            {/* Confirmação de remoção */}
            <Dialog open={confirmacaoAberta} onClose={() => setConfirmacaoAberta(false)}>
                <DialogTitle>Remover bairro</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Tem certeza que deseja remover este bairro? Esta ação não pode ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmacaoAberta(false)} color="default">
                        Cancelar
                    </Button>
                    <Button onClick={handleConfirmarRemocao} style={{ color: "var(--cor-erro)" }}>
                        Remover
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal adicionar cidade */}
            <Dialog
                open={modalCidadeAberto}
                onClose={() => { setModalCidadeAberto(false); setCidadeSelecionadaAdicionar(null) }}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Adicionar Cidade</DialogTitle>
                <DialogContent>
                    <Autocomplete
                        options={todasCidades}
                        getOptionLabel={c => c.nomeCompleto ?? c.nome}
                        value={cidadeSelecionadaAdicionar}
                        onChange={(_, value) => setCidadeSelecionadaAdicionar(value)}
                        noOptionsText="Nenhuma cidade encontrada"
                        filterOptions={(options, { inputValue }) => {
                            const termo = inputValue.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()
                            if (!termo) return []
                            return options.filter(c => {
                                const nome = c.nome.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()
                                return nome.startsWith(termo)
                            })
                        }}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Digite o nome da cidade"
                                variant="outlined"
                                size="small"
                                style={{ marginTop: 8 }}
                            />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => { setModalCidadeAberto(false); setCidadeSelecionadaAdicionar(null) }}
                        color="default"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleAdicionarCidade}
                        style={{ color: "#4caf50" }}
                        disabled={!cidadeSelecionadaAdicionar}
                    >
                        Adicionar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal remover cidade */}
            <Dialog
                open={modalRemoverCidadeAberto}
                onClose={() => setModalRemoverCidadeAberto(false)}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Remover Cidade</DialogTitle>
                <DialogContent>
                    <FormControl variant="outlined" size="small" fullWidth style={{ marginTop: 8 }}>
                        <InputLabel>Selecione uma cidade</InputLabel>
                        <Select
                            value={cidadeSelecionadaRemover}
                            onChange={e => setCidadeSelecionadaRemover(e.target.value as number)}
                            label="Selecione uma cidade"
                        >
                            {cidadesEstabelecimento.map(c => (
                                <MenuItem key={c.id} value={c.id}>
                                    {c.nome}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setModalRemoverCidadeAberto(false)} color="default">
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleRemoverCidade}
                        style={{ color: "var(--cor-erro)" }}
                        disabled={!cidadeSelecionadaRemover}
                    >
                        Remover
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
